<template>
  <div class="ui-full-calendar-control">
    <div class="ui-full-calendar-control__block--left">
      <p class="ui-full-calendar-control-date">
        {{ formatDate }}
      </p>
      <ui-icon
          name="left"
          :width="16"
          :height="16"
          @click="prevDate"
          class="ui-full-calendar-control-button left"
      />
    </div>
    <ui-icon
        name="right"
        :width="16"
        :height="16"
        @click="nextDate"
        class="ui-full-calendar-control-button"
    />
  </div>
</template>

<script>
import UiIcon from '../icons/UiIcon.vue'
import { dateFormat } from '../../libs/date'
import { TYPE_DAY, TYPE_MONTH, TYPE_WEEK } from './calendarConst.js'
export default {
  name: 'UiFullCalendarControl',
  components: { UiIcon },
  props: {
    rangeDates: {
      type: Object,
      default: () => ({})
    },
    type: {
      type: String,
      default: TYPE_MONTH
    }
  },

  computed: {
    formatDate () {
      const startDate = this.rangeDates.start?.date
      const endDate = this.rangeDates.end?.date
      switch (this.type) {
        case TYPE_DAY:
          return dateFormat(endDate, 'DD, MMMM YYYY', false)
        case TYPE_WEEK:
          return `${dateFormat(startDate, 'DD MMM', false)} - ${dateFormat(endDate, 'DD MMM YYYY', false)}`
        case TYPE_MONTH:
          return dateFormat(startDate, 'MMMM YYYY', false)
      }
    }
  },

  methods: {
    prevDate () {
      this.$emit('click-prev-date')
    },

    nextDate () {
      this.$emit('click-next-date')
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-full-calendar-control {
  display: flex;
  align-items: center;
  height: 40px;
  width: max-content;
  padding: 0 24px;
  background-color: $gray-7;
  border-radius: $border-radius-00;
  color: $gray-2;
  fill: $gray-2;
}

.ui-full-calendar-control-date {
  @include font-title-18;

  min-width: 182px;
  margin-right: 6px;
  margin-bottom: 0;
  color: $gray-2;
  text-transform: capitalize;
  white-space: nowrap;
}

.ui-full-calendar-control__block--left {
  display: flex;
  align-items: center;
}

.ui-full-calendar-control-button {
  cursor: pointer;

  &.left {
    margin-right: 25px;
  }
}
</style>
